import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useBureauAccess, useBureauMe } from '../../api/bureau.js';
import '../../styles/bureau.css';

// Bandeau « moment en cours » affiché sur toutes les pages de la
// responsable du bureau, hors /bureau : l'oubli vient de ce qu'elle est
// ailleurs (Saisie, Grille) quand l'heure tombe. « Plus tard » le masque
// 15 minutes dans cet onglet ; les rappels push suivent leur propre rythme.
export function BureauStrip() {
  const access = useBureauAccess();
  const me = useBureauMe(access.view);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [hiddenUntil, setHiddenUntil] = useState<{ id: string; at: number } | null>(null);
  const cur = me.data?.isAssignee ? me.data.current : null;
  if (!cur || pathname === '/bureau') return null;
  if (hiddenUntil && hiddenUntil.id === cur.id && Date.now() < hiddenUntil.at) return null;
  return (
    <div className={cur.late ? 'bx-strip is-late' : 'bx-strip'} role="status" data-testid="bureau-strip">
      <span className="bx-strip-dot" aria-hidden="true" />
      <span className="bx-strip-text">
        <b>{cur.time}</b> {cur.label} · {cur.remaining} point{cur.remaining > 1 ? 's' : ''}{cur.late ? ' · en retard' : ''}
      </span>
      <button type="button" className="bx-strip-go" onClick={() => navigate('/bureau?vue=journee')}>Faire</button>
      <button type="button" className="bx-strip-later" onClick={() => setHiddenUntil({ id: cur.id, at: Date.now() + 15 * 60_000 })}>
        Plus tard
      </button>
    </div>
  );
}
